var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRecurringInvoice = function SvgRecurringInvoice(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "url(#recurring-invoice_svg__a)",
    rx: 16
  })), /*#__PURE__*/React.createElement("mask", {
    id: "recurring-invoice_svg__b",
    width: 24,
    height: 24,
    x: 4,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M4 4h24v24H4z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    mask: "url(#recurring-invoice_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 8v6.179-.025V24zm.308 17.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V8.308q0-.758.525-1.283T9.308 6.5h7.194q.366 0 .697.14a1.8 1.8 0 0 1 .578.387l4.196 4.196a1.8 1.8 0 0 1 .527 1.275v1.354a.7.7 0 0 1-.216.527.74.74 0 0 1-.534.207.73.73 0 0 1-.535-.215.73.73 0 0 1-.215-.535V12.5h-3.6a.87.87 0 0 1-.641-.259.87.87 0 0 1-.259-.641V8H9.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v15.384q0 .116.096.212a.3.3 0 0 0 .212.096h5.356q.318 0 .534.216a.73.73 0 0 1 .216.534q0 .32-.216.535a.73.73 0 0 1-.534.215z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.31 25.563a.58.58 0 0 1-.596-.595.58.58 0 0 1 .596-.597h1.04a5.4 5.4 0 0 1-1.186-1.642 4.6 4.6 0 0 1-.45-2.012q0-1.476.791-2.666a4.74 4.74 0 0 1 2.084-1.755.46.46 0 0 1 .421-.005q.194.102.29.319t.02.447-.373.381a3.6 3.6 0 0 0-1.477 1.32 3.54 3.54 0 0 0-.564 1.96q0 .82.354 1.551.354.732.954 1.273v-1.075a.58.58 0 0 1 .596-.596.58.58 0 0 1 .596.596v2.193q0 .384-.26.644a.88.88 0 0 1-.644.26zm6.121-.425a.46.46 0 0 1-.429 0 .65.65 0 0 1-.298-.323.6.6 0 0 1-.02-.447q.075-.23.374-.381a3.75 3.75 0 0 0 1.482-1.338 3.5 3.5 0 0 0 .559-1.932q0-.82-.354-1.552a4.1 4.1 0 0 0-.954-1.273v1.075a.58.58 0 0 1-.596.596.58.58 0 0 1-.596-.596v-2.192q0-.383.26-.644a.88.88 0 0 1 .643-.26h2.193a.58.58 0 0 1 .596.596.58.58 0 0 1-.596.596h-1.04q.735.694 1.186 1.643.45.948.45 2.011 0 1.477-.791 2.667a4.75 4.75 0 0 1-2.069 1.754"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "recurring-invoice_svg__a",
    x1: 3,
    x2: 36,
    y1: 30,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F2E55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4277FC"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRecurringInvoice);
export default ForwardRef;